import { v4 as uuid } from "uuid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { CustomerType } from "@/modules/space/constants/customerType"
import { BannerType } from "@/core/components/HeroBanner/constants/bannerType"

@Serializable
export class Banner {
  uid: string = uuid()
  text: string = ""
  link: string | null = null
  link_label: string | null = null
  expiry: string = ""
  type: BannerType = BannerType.Info
  customer_type: CustomerType = CustomerType.RFQReceiver
  created: string = new Date().toISOString()
  updated: string = new Date().toISOString()

  constructor(
    data: {
      uid: string
      text: string
      link: string | null
      link_label: string | null
      expiry: string
      type: BannerType
      customer_type: CustomerType
      created: string
      updated: string
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.text = data.text
      this.link = data.link
      this.link_label = data.link_label
      this.expiry = data.expiry
      this.type = data.type
      this.customer_type = data.customer_type
      this.created = data.created
      this.updated = data.updated
    }
  }
}
